import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col full-width full-height references-compact-container min-height" }
const _hoisted_2 = { class: "references-header-container" }
const _hoisted_3 = { class: "references-index-container" }
const _hoisted_4 = { class: "references-article-container" }

import ReferencesIndex from 'components/references/ReferencesIndex.vue';
import ReferencesDetail from 'components/references/ReferencesDetail.vue';
import ReferencesHeader from 'components/references/ReferencesHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesPaneCompact',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(ReferencesHeader)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ReferencesIndex)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(ReferencesDetail)
    ])
  ]))
}
}

})